import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../style.css';

const privateClasses = [
  { duration: "1 hour", price: 17 },
  { duration: "10 hours", price: 150 },
  { duration: "20 hours", price: 270 },
  { duration: "40 hours", price: 500 },
  { duration: "60 hours", price: 690 },
  { duration: "80 hours", price: 880 },
];

const onlineClasses = [
  { duration: "1 hour", price: 12 },
  { duration: "10 hours", price: 110 },
  { duration: "20 hours", price: 200 },
  { duration: "40 hours", price: 380 },
];

function SpanishFees() {
  return (
    <div className="page-wrapper">
      <Helmet>
        <title>Spanish Class Fees | Culturlingua — Tlaquepaque, Jalisco</title>
        <meta name="description" content="Spanish class fees at Culturlingua. Private and online tutoring packages starting at $12 USD/hour. Classes start every Monday." />
      </Helmet>

      <div className="page-hero">
        <div className="section-tag">Transparent Pricing</div>
        <h1>Our Fees</h1>
        <p>Classes start every Monday. Personalized programs for every budget and schedule.</p>
      </div>

      <section style={{background:'var(--cream)', padding:'80px 48px'}}>
        <div style={{maxWidth:'900px', margin:'0 auto'}}>

          <div style={{background:'white', borderRadius:'20px', padding:'40px', boxShadow:'0 2px 16px rgba(0,0,0,0.06)', marginBottom:'32px'}}>
            <p style={{color:'var(--muted)', lineHeight:'1.8', marginBottom:'12px'}}>
              Our classes are planned to meet your learning needs. Your class can start any Monday in the year.
              Let us know when you want to start <strong>2 weeks in advance</strong> to plan teachers' schedules and class materials.
            </p>
            <p style={{color:'var(--text)', fontWeight:'600'}}>
              The classes have a duration of 4 hours per day, 5 days a week — but we are adaptable to your needs.
            </p>
          </div>

          <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'24px', marginBottom:'48px'}}>

            <div style={{background:'white', borderRadius:'20px', overflow:'hidden', boxShadow:'0 2px 16px rgba(0,0,0,0.06)'}}>
              <div style={{background:'var(--navy)', padding:'24px 28px'}}>
                <div style={{color:'var(--gold)', fontSize:'0.75rem', fontWeight:'700', textTransform:'uppercase', letterSpacing:'1px', marginBottom:'4px'}}>Face-to-Face</div>
                <h3 style={{fontFamily:'Fraunces, serif', color:'white', fontSize:'1.3rem', fontWeight:'900'}}>Private Lessons</h3>
              </div>
              <div style={{padding:'24px'}}>
                {privateClasses.map((item, i) => (
                  <div key={i} style={{display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 0', borderBottom: i < privateClasses.length - 1 ? '1px solid #e5e7eb' : 'none'}}>
                    <span style={{color:'var(--text)', fontWeight:'500'}}>{item.duration}</span>
                    <span style={{fontFamily:'Fraunces, serif', fontWeight:'900', color:'var(--navy)', fontSize:'1.1rem'}}>${item.price} USD</span>
                  </div>
                ))}
              </div>
            </div>

            <div style={{background:'white', borderRadius:'20px', overflow:'hidden', boxShadow:'0 2px 16px rgba(0,0,0,0.06)'}}>
              <div style={{background:'linear-gradient(135deg, var(--blue), var(--blue-light))', padding:'24px 28px'}}>
                <div style={{color:'rgba(255,255,255,0.7)', fontSize:'0.75rem', fontWeight:'700', textTransform:'uppercase', letterSpacing:'1px', marginBottom:'4px'}}>Virtual</div>
                <h3 style={{fontFamily:'Fraunces, serif', color:'white', fontSize:'1.3rem', fontWeight:'900'}}>Online Private Lessons</h3>
              </div>
              <div style={{padding:'24px'}}>
                {onlineClasses.map((item, i) => (
                  <div key={i} style={{display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 0', borderBottom: i < onlineClasses.length - 1 ? '1px solid #e5e7eb' : 'none'}}>
                    <span style={{color:'var(--text)', fontWeight:'500'}}>{item.duration}</span>
                    <span style={{fontFamily:'Fraunces, serif', fontWeight:'900', color:'var(--navy)', fontSize:'1.1rem'}}>${item.price} USD</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div style={{background:'rgba(59,111,224,0.06)', border:'1px solid rgba(59,111,224,0.15)', borderRadius:'12px', padding:'20px 24px', marginBottom:'40px'}}>
            <p style={{color:'var(--text)', fontWeight:'600', marginBottom:'4px'}}>💳 Payment Methods</p>
            <p style={{color:'var(--muted)', fontSize:'0.9rem'}}>We gladly accept payment in Pesos, Dollars, Traveler's checks, PayPal or Credit cards.</p>
            <p style={{color:'var(--muted)', fontSize:'0.9rem', marginTop:'8px'}}>✈️ Airport pickup available: $20 USD — we take you directly to your accommodation.</p>
          </div>

          <div style={{textAlign:'center', display:'flex', gap:'16px', justifyContent:'center', flexWrap:'wrap'}}>
            <Link to="/Placement-Test" className="btn-glow">Take Placement Test →</Link>
            <Link to="/contacto" className="btn-outline" style={{color:'var(--navy)', border:'1.5px solid var(--navy)'}}>Contact Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default SpanishFees;
